export default "__VITE_ASSET__CRkQDu7F__"